import {
    SET_USERS,
    SET_ONE_USER,
    SET_NEW_USER,
    SET_EDIT_USER,
    SET_DELETE_USER,
    SET_DELETE_MULTI_USER,
    RESET_ITEMS_USER,
    RESET_SELECTED_USER,
    SET_LIST_USERS,
    RESET_LIST_USERS,
    SET_EDIT_PROFILE,
    SET_PASSWORD_CHANGE,
    SET_USER_TOKEN,
    RESET_USER_TOKEN,
} from "redux/constants/Users";

import { SET_AUTH_USER } from "redux/constants/Auth";

import { getFormData, RequestResultFunction } from "./requestFunction";

import * as api from "api/user.js";
import { CHANGE_LOCALE } from "redux/constants/Theme";

export const getUsers = () => async (dispatch) => {
    RequestResultFunction(dispatch, api.getRequest(), SET_USERS);
};
export const getListUsers = () => async (dispatch) => {
    RequestResultFunction(dispatch, api.getListRequest(), SET_LIST_USERS);
};

export const getUser = (id) => async (dispatch) => {
    RequestResultFunction(dispatch, api.getOneRequest(id), SET_ONE_USER);
};

export const createUser = (user) => async (dispatch) => {
    const formData = getFormData(user);
    RequestResultFunction(dispatch, api.createRequest(formData), SET_NEW_USER);
};

export const updateUser = (id, user) => async (dispatch) => {
    const formData = getFormData(user);
    RequestResultFunction(
        dispatch,
        api.updateRequest(id, formData),
        SET_EDIT_USER
    );
};

export const editProfile = (user) => async (dispatch) => {
    const formData = getFormData(user);
    RequestResultFunction(dispatch, api.editProfileRequest(formData), [
        SET_EDIT_PROFILE,
        SET_AUTH_USER,
    ]);
};

export const passwordChange = (user) => async (dispatch) => {
    RequestResultFunction(
        dispatch,
        api.passwordChangeRequest(user),
        SET_PASSWORD_CHANGE
    );
};
export const changeLanguageDB = (locale) => async (dispatch) => {
    RequestResultFunction(
        dispatch,
        api.changeLanguageRequest(locale),
        SET_PASSWORD_CHANGE
    );
    //SET_PASSWORD_CHANGE hicbirsey yapmiyor
    dispatch({ type: CHANGE_LOCALE, locale });
};

export const sendEmailReset = (user) => async (dispatch) => {
    // const form_data = getFormData(user);

    RequestResultFunction(
        dispatch,
        api.emailResetRequest(user),
        SET_PASSWORD_CHANGE
    );
};
export const passwordReset = (user) => async (dispatch) => {
    const userId = user.uid;
    const token = user.token;

    RequestResultFunction(
        dispatch,
        api.passwordResetRequest(userId, token, user),
        SET_PASSWORD_CHANGE
    );
};
export const passwordAdminReset = (email) => async (dispatch) => {
    RequestResultFunction(
        dispatch,
        api.passwordAdminResetRequest({ email }),
        SET_USER_TOKEN
    );
};

export const deleteUser = (id) => async (dispatch) => {
    RequestResultFunction(dispatch, api.deleteRequest(id), SET_DELETE_USER, id);
};

export const deleteMultiUser = (ids) => async (dispatch) => {
    RequestResultFunction(
        dispatch,
        api.deleteMultiRequest(ids),
        SET_DELETE_MULTI_USER,
        ids
    );
};

export const resetUserToken = () => async (dispatch) => {
    dispatch({ type: RESET_USER_TOKEN });
};
export const resetItemsUser = () => async (dispatch) => {
    dispatch({ type: RESET_ITEMS_USER });
};
export const resetListUsers = () => async (dispatch) => {
    dispatch({ type: RESET_LIST_USERS });
};

export const resetSelectedUser = () => async (dispatch) => {
    dispatch({ type: RESET_SELECTED_USER });
};
